var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3601 4.57866L15.2869 3.65178C16.8226 2.11607 19.3125 2.11607 20.8482 3.65178C22.3839 5.18748 22.3839 7.67735 20.8482 9.21306L19.9213 10.1399M14.3601 4.57866C14.3601 4.57866 14.4759 6.54828 16.2138 8.28618C17.9517 10.0241 19.9213 10.1399 19.9213 10.1399M14.3601 4.57866L5.83882 13.0999C5.26166 13.6771 4.97308 13.9656 4.7249 14.2838C4.43213 14.6592 4.18114 15.0653 3.97634 15.495C3.80273 15.8593 3.67368 16.2465 3.41556 17.0208L2.32181 20.3021M19.9213 10.1399L11.4001 18.6612C10.8229 19.2383 10.5344 19.5269 10.2162 19.7751C9.84082 20.0679 9.43469 20.3189 9.00498 20.5237C8.6407 20.6973 8.25352 20.8263 7.47918 21.0844L4.19792 22.1782M4.19792 22.1782L3.39584 22.4456C3.01478 22.5726 2.59466 22.4734 2.31063 22.1894C2.0266 21.9053 1.92743 21.4852 2.05445 21.1042L2.32181 20.3021M4.19792 22.1782L2.32181 20.3021",
    stroke: "#00A991",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.94effb9c56c54c203d1de06213b29c25.svg";
export { ForwardRef as ReactComponent };